import React, { useMemo, useState } from 'react';
import { Calendar } from 'lucide-react';
import DateRangePicker from '@/shared/components/ui/utility/DateRangePicker';
import { getTodayMockDate } from '@/shared/utils/dateUtils';

export default function DateRangeModal({ onClose, data }) {
  const today = useMemo(() => getTodayMockDate(), []);
  const initial = data?.initialRange && data.initialRange.from && data.initialRange.to
    ? data.initialRange
    : { from: today, to: today };

  const [range, setRange] = useState(initial);

  const apply = () => {
    if (typeof data?.onApply === 'function') {
      data.onApply(range);
    }
    onClose?.();
  };

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2">
        <Calendar className="h-5 w-5 text-primary-600" />
        <h2 className="text-lg font-semibold">Select Date Range</h2>
      </div>
      <p className="text-sm text-secondary-600">Pick a start and end date. Defaults to today.</p>

      <DateRangePicker value={range} onChange={setRange} />

      <div className="flex justify-end gap-3 pt-2">
        <button
          type="button"
          onClick={onClose}
          className="inline-flex items-center px-3 py-2 rounded-md border bg-white text-secondary-700 hover:bg-secondary-50"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={apply}
          className="inline-flex items-center px-3 py-2 rounded-md bg-primary-600 text-white hover:bg-primary-700"
        >
          Apply
        </button>
      </div>
    </div>
  );
}
